// FLAGS: none
// Markdown editor for the optional event description.
import {
  MDXEditor,
  headingsPlugin,
  listsPlugin,
  quotePlugin,
  linkPlugin,
  linkDialogPlugin,
  markdownShortcutPlugin,
  toolbarPlugin,
  UndoRedo,
  BoldItalicUnderlineToggles,
  ListsToggle,
  CreateLink,
} from "@mdxeditor/editor";
import "@mdxeditor/editor/style.css";

interface MarkdownDescriptionEditorProps {
  value: string;
  onChange: (markdown: string) => void;
}

const ToolbarContents = () => (
  <>
    <UndoRedo />
    <BoldItalicUnderlineToggles />
    <ListsToggle options={["bullet", "number"]} />
    <CreateLink />
  </>
);

/**
 * Rich-text (markdown) description editor for the create-event form, using the
 * ecosystem's MDXEditor (same as OpenUp.Admin). Stores markdown; the invitee-facing
 * detail page renders it back to formatted text.
 */
const MarkdownDescriptionEditor = ({
  value,
  onChange,
}: MarkdownDescriptionEditorProps) => (
  <MDXEditor
    markdown={value}
    onChange={onChange}
    placeholder="Optional summary shown to invitees"
    className="rounded-lg border border-gray-300 bg-white"
    contentEditableClassName="min-h-[120px] text-sm text-gray-800"
    plugins={[
      headingsPlugin(),
      listsPlugin(),
      quotePlugin(),
      linkPlugin(),
      linkDialogPlugin(),
      markdownShortcutPlugin(),
      toolbarPlugin({ toolbarContents: ToolbarContents }),
    ]}
  />
);

export default MarkdownDescriptionEditor;
